import {match} from 'ts-pattern';

import {EntityResourceIds} from '@dms/api/shared';
import {TaskRelations} from '@dms/features/tasks';

/**
 * @param pathname - URL pathname, beginning with a /.
 */
export function getEntityResourceIdFromPathname(pathname: string) {
  const entity = pathname.split('/')?.at(1);
  const subEntity = pathname.split('/')?.at(2);

  return match({entity, subEntity})
    .returnType<TaskRelations | undefined>()
    .with({entity: 'customer'}, () => EntityResourceIds.customer)
    .with({entity: 'vehicles'}, () => EntityResourceIds.vehicle)
    .with({entity: 'business-case'}, () => EntityResourceIds.businessCase)
    .with({entity: 'interest'}, () => EntityResourceIds.interest)
    .with({entity: 'workshop', subEntity: 'service-cases'}, () => EntityResourceIds.serviceCase)
    .with(
      {entity: 'workshop', subEntity: 'draft-service-case'},
      () => EntityResourceIds.serviceCase
    )
    .with({entity: 'warehouses', subEntity: 'direct-sales'}, () => EntityResourceIds.directSale)
    .with({entity: 'tires-inventory', subEntity: 'tire-order'}, () => EntityResourceIds.tireOrder)
    .otherwise(() => undefined);
}
